import React from 'react';
import { Layout as AntLayout } from '@vertem-core/vertice-ds';
import { LayoutProps } from 'antd/lib/layout';

const LayoutComponent: React.FC<LayoutProps> = (props: LayoutProps) => (
  <>
    {props.children}
  </>
);

const Layout = LayoutComponent as typeof LayoutComponent & {
  Header: typeof AntLayout.Header;
  Footer: typeof AntLayout.Footer;
  Content: typeof AntLayout.Content;
};

Layout.Header = AntLayout.Header;
Layout.Footer = AntLayout.Footer;
Layout.Content = AntLayout.Content;

export default Layout;
